const fontWeight = {
  normal: '400',
  medium: '500',
  bold: '700',
}

export default fontWeight
